export default {
	list: []
}
